import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  STATUS: {
    id: 'Status.status',
    defaultMessage: 'Status',
    description: '[Type: Label][Vis.: low] - Status link in main navigation',
  },
});

const Status = () => (
  <MainNavButton href="/tools/api_status/" label={t(COPY.STATUS)} />
);

export default Status;
export { Status };
